import { render, staticRenderFns } from "./ReportLink.vue?vue&type=template&id=2bfe3c58&"
import script from "./ReportLink.vue?vue&type=script&lang=js&"
export * from "./ReportLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports